import { render, staticRenderFns } from "./PlaceholderEventDescription.vue?vue&type=template&id=87960896&"
import script from "./PlaceholderEventDescription.vue?vue&type=script&lang=js&"
export * from "./PlaceholderEventDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports